var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statement-react"},[_c('add-button',{attrs:{"statement":_vm.statement},on:{"toggleOn":function($event){_vm.addFormStatement(_vm.statement)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }